/* unplugin-vue-components disabled */import script from "./app.vue?vue&type=script&setup=true&lang=ts"
export * from "./app.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__